import {ReactComponent as LeaderIcon} from "../../assets/soft-skill-icons/leader.svg";
import {ReactComponent as FollowerIcon} from "../../assets/soft-skill-icons/follower.svg";
import {ReactComponent as HardIcon} from "../../assets/soft-skill-icons/hard.svg";
import {ReactComponent as ImpulsiveIcon} from "../../assets/soft-skill-icons/impulsive.svg";
import {ReactComponent as PragmaticIcon} from "../../assets/soft-skill-icons/pragmatic.svg";
import {ReactComponent as SoftIcon} from "../../assets/soft-skill-icons/soft.svg";
import {ReactComponent as ThoughtfulIcon} from "../../assets/soft-skill-icons/thoughtful.svg";
import {ReactComponent as VisionaryIcon} from "../../assets/soft-skill-icons/visionary.svg";
import {FunctionComponent, SVGProps} from "react";

export interface BgItemTypeToPathI {
    QUAL: string;
    JOB: string;
    LANG: string;
    COMP: string;
    LIFE: string;
    MAT: string;
}

export const bgItemTypeToPath = {
    QUAL: "qualifications",
    JOB: "jobs",
    LANG: "languages",
    COMP: "competences",
    LIFE: "others",
    MAT: "materials",
};

export const LANDING_URL = "https://stepsconnect.com";
export const SUBDOMAIN_URL = "https://steps-c4a79.web.app/";

export const ROUTES = {
    HOME: "/",
    STUDENT_HOME: "/",
    LOGIN: "/login",
    SIGNUP_STUDENT: "/emoji/assessment",
    SIGNUP_STUDENT_SCHOOL: "/signup/student-school",
    SIGNUP_STUDENT_COMPANY_BOUNDED: "/signup/student-company-bounded",
    STUDENT_ONBOARDING: "/me/onboarding",
    STUDENT_ONBOARDING_EMOJI: "/me/onboarding/emoji",
    STUDENT_ONBOARDING_WELCOME: "/me/onboarding/welcome",
    STUDENT_ONBOARDING_GENERAL: "/me/onboarding/general",
    STUDENT_ONBOARDING_STUDY: "/me/onboarding/study",
    STUDENT_ONBOARDING_COMPETENCE: "/me/onboarding/competence",
    STUDENT_ONBOARDING_LANGUAGE: "/me/onboarding/language",
    STUDENT_ONBOARDING_JOB: "/me/onboarding/job",
    STUDENT_ONBOARDING_FINAL: "/me/onboarding/final",
    SIGNUP_COMPANY: "/signup/company",
    STUDENT_TEST: "/me/test",
    EMOJI: "/emoji",
    EMOJI_ASSESSMENT: "/emoji/assessment",
    EMOJI_SIGNUP: "/emoji/signup",
    STUDENT_INTEREST: "/me/interest",
    ME: "/me",
    FEED: "/me/feed",
    STUDENT_RM: "/me/rm/:rmId",
    STUDENT_RM_COMING: "/me/coming/rm/:rmId",
    COMPANY_GAME: "/me/rm/games/game",
    STUDENT_AFOL: "/me/afol",
    STUDENT_AFOL_ONBOARDING: "/me/afol/onboarding",
    STUDENT_AFOL_PROFILE: "/me/afol/profile",
    STUDENT_AFOL_COURSES: "/me/afol/courses",
    STUDENT_AFOL_ACTIVITIES: "/me/afol/activities",
    FOLLOW: "/me/follow/:rmId",
    FOLLOW_GAME: "/me/follow/:rmId/game",
    SETTINGS: "/me/settings",
    FOLLOWER: "/me/rm/follower",
    COMPANY_RM: "/me/rm/",
    COMPANY_RM_EDIT_SOFT: "/me/rm/edit-soft",
    COMPANY_RM_GAMES: "/me/rm/games",
    COMPANY_RM_GAMES_GAME: "/me/rm/games/game",
    COMPANY_RM_OVERVIEW: "/me/rm/overview",
    COMPANY_RM_ANALYTICS: "/me/rm/analytics",
    COMPANY_RM_VIDEOS: "/me/rm/videos",
    PROFILE: "/me/profile",
    COMPANY: "/me/company/:companyId",
    SPECIAL: "/me/special",
    NOT_FOUND: "/404",
    ADMIN_NEW_SCHOOL: "/me/new-school",
    ADMIN_NEW_COMPANY: "/me/new-company",
    ADMIN_NEW_TUTOR: "/me/new-tutor",
    ADMIN_PWC_USERS: "/me/pwc-users",
    TUTOR_VIEW_PROFILE: "/me/afol/profile",
    ADMIN_SCHOOL: "/me/schools/:schoolId",
    ADMIN_SCHOOLS: "/me/schools",
    ADMIN_RMS: "/me/rms",
    PRIVACY: "/me/privacy",
    TERMS: "/me/terms",
    COOKIE: "/me/cookie",
};

export const bgItemTypeToTitle = {
    QUAL: "Istruzione",
    JOB: "Lavoro",
    LANG: "Lingua",
    COMP: "Competenza tecnica",
    LIFE: "Esperienza di vita",
};

export const followState = {
    IN: "IN",
    OUT: "OUT",
};

export const radarInit = {
    HARD: 1,
    SOFT: 1,
    THOUGHTFUL: 1,
    IMPULSIVE: 1,
    PRAGMATIC: 1,
    VISIONARY: 1,
    LEADER: 1,
    FOLLOWER: 1,
};

export interface SoftSkillsDatasetItemInterface {
    label: String;
    storageFileName: String;
    description: string;
    icon: FunctionComponent<SVGProps<SVGSVGElement> & { title?: string | undefined }>;
    emoji: string;
}

export const gameRequests = [
    {id: "pdf", label: "company_rm_editGame_request_pdf"},
    {id: "image", label: "company_rm_editGame_request_img"},
    {id: "audio", label: "company_rm_editGame_request_audio"},
    {id: "video", label: "company_rm_editGame_request_video"},
    {id: "excel", label: "company_rm_editGame_request_excel"},
    {id: "external", label: "company_rm_editGame_request_external"},
];

export const softSkillsDataset: {
    [key: string]: SoftSkillsDatasetItemInterface;
} = {
    LEADER: {
        label: "ss_leader_label",
        storageFileName: "ispiratore.png",
        description: "ss_leader_desc",
        icon: LeaderIcon,
        emoji: "📣",
    },
    VISIONARY: {
        label: "ss_visionary_label",
        storageFileName: "pensatore.png",
        description: "ss_visionary_desc",
        icon: VisionaryIcon,
        emoji: "💭",
    },
    SOFT: {
        label: "ss_soft_label",
        storageFileName: "networker.png",
        description: "ss_soft_desc",
        icon: SoftIcon,
        emoji: "🤝",
    },
    IMPULSIVE: {
        label: "ss_impulsive_label",
        storageFileName: "sonda-spaziale.png",
        description: "ss_impulsive_desc",
        icon: ImpulsiveIcon,
        emoji: "🚀",
    },
    FOLLOWER: {
        label: "ss_follower_label",
        storageFileName: "playmaker.png",
        description: "ss_follower_desc",
        icon: FollowerIcon,
        emoji: "🏀",
    },
    PRAGMATIC: {
        label: "ss_pragmatic_label",
        storageFileName: "costruttore.png",
        description: "ss_pragmatic_desc",
        icon: PragmaticIcon,
        emoji: "🔧",
    },
    HARD: {
        label: "ss_hard_label",
        storageFileName: "specialista.png",
        description: "ss_hard_desc",
        icon: HardIcon,
        emoji: "🎯",
    },
    THOUGHTFUL: {
        label: "ss_thoughtful_label",
        storageFileName: "bilancia.png",
        description: "ss_thoughtful_desc",
        icon: ThoughtfulIcon,
        emoji: "⚖️"
    }
};

export const analyticsEvents = {
    VIVAIO_JOIN: "vivaio_join",
    VIVAIO_LEAVE: "vivaio_leave",
    SIGNUP: "signup",
    EMOJI_HERO: "emoji_hero",
    EMOJI_ASSESSMENT_START: "emoji_assessment_start",
    EMOJI_ASSESSMENT_CLOSE: "emoji_assessment_close",
    EMOJI_ASSESSMENT_COMPLETE: "emoji_assessment_complete",
    EMOJI_SIGNUP: "emoji_signup",
    EMOJI: "emoji",
    ASSESSMENT_START: "assessment_start",
    ASSESSMENT_CLOSE: "assessment_close",
    ASSESSMENT_COMPLETE: "assessment_complete",
    CIAO_ANSIA_CLICK: "ciao_ansia_click",
    USEFUL_DEGREE: "useful_degree",
    OPEN_SIGNUP_FROM_LOGIN: "open_signup_from_login",
    OPEN_SIGNUP_STUDENT_HERO: "open_signup_student_hero",
    OPEN_SIGNUP_STUDENT_SECTION_1: "open_signup_student_section_1",
    OPEN_SIGNUP_STUDENT_SECTION_2: "open_signup_student_section_2",
    OPEN_SIGNUP_STUDENT_SECTION_3: "open_signup_student_section_3",
    OPEN_SIGNUP_COMPANY_HERO: "open_signup_company_hero",
    OPEN_SIGNUP_COMPANY_SECTION_1: "open_signup_company_section_1",
    OPEN_SIGNUP_COMPANY_SECTION_2: "open_signup_company_section_2",
    OPEN_SIGNUP_COMPANY_SECTION_3: "open_signup_company_section_3",
    CHATBOT_OPEN: "chatbot_open",
    CHATBOT_SELECT_OPTION: "chatbot_select_option",
    CHATBOT_HIT: "chatbot_hit",
    CHATBOT_MISS: "chatbot_miss",
    LAUREA_VISITED: "laurea_visited",
    LAUREA_DISCOVER_BUTTON: "laurea_discover_button",
    LAUREA_OPEN_SIGNUP: "laurea_open_signup",
    LAUREA_SIGNUP: "laurea_signup",
    BLOG_VISITED: "blog_visited",
    ARTICLE_CLICKED: "article_clicked",
    CV_NEWSLETTER: "cv_newsletter",
    CV_DOWNLOAD: "cv_download",
    ACTIVE_USER: "active_user",
    CV_FILL: "cv_fill",
    COURSE: "course",
    GAME: "game"
};

export enum bgItemTypes {
    QUAL = "QUAL",
    JOB = "JOB",
    LANG = "LANG",
    COMP = "COMP",
    LIFE = "LIFE",
    MAT = "MAT",
}

export const jobContracts = [
    {id: 0, label: "ds_jobContract_0"},
    {id: 1, label: "ds_jobContract_1"},
    {id: 2, label: "ds_jobContract_2"},
    {id: 3, label: "ds_jobContract_3"},
    {id: 4, label: "ds_jobContract_4"},
];

export const competenceLevels = [
    {id: 0, label: "ds_compLevel_0"},
    {id: 1, label: "ds_compLevel_1"},
    {id: 2, label: "ds_compLevel_2"},
    {id: 3, label: "ds_compLevel_3"},
];

export const qualificationTypes = [
    {id: 1, label: "ds_qualType_1"},
    {id: 2, label: "ds_qualType_2"},
    {id: 3, label: "ds_qualType_3"},
    {id: 4, label: "ds_qualType_4"},
    {id: 5, label: "ds_qualType_5"},
    {id: 6, label: "ds_qualType_6"},
    {id: 7, label: "ds_qualType_7"},
];

export const companyDimensions = [
    {id: 0, label: "0-1"},
    {id: 1, label: "2-10"},
    {id: 2, label: "11-50"},
    {id: 3, label: "51-200"},
    {id: 4, label: "201-500"},
    {id: 5, label: "501-1000"},
    {id: 6, label: "1001-5000"},
    {id: 7, label: "5001-10000"},
    {id: 8, label: ">10000"},
];

export const companyTypes = {
    1: "Ente governativo",
    2: "Impresa individuale",
    3: "Lavoratore autonomo",
    4: "Non profit",
    5: "Società di persone",
    6: "Società privata non quotata",
    7: "Società quotata",
};

export const languageLevels = [
    {id: 0, label: "A1"},
    {id: 1, label: "A2"},
    {id: 2, label: "B1"},
    {id: 3, label: "B2"},
    {id: 4, label: "C1"},
    {id: 5, label: "C2"},
    {id: 6, label: "Mothertongue"},
];

export const userRoles = {
    STUDENT: "student",
    COMPANY: "company",
    ADMIN: "admin",
};
